<div class="!p-3 rounded-lg border bg-white shadow-lg w-[400px]">
    <ng-container *ngFor="let room of cancelPolicies; let i = index">
        <!-- Xử lý trường hợp chỉ có một chính sách -->
        <div *ngIf="cancelPolicies.length == 1"  class="flex !gap-1 !h-fit">
            <!-- icon dot -->
            <div class="!w-4 !h-4 !my-[2px] flex items-center justify-center  rounded-full"
                [ngClass]="room.charge ? 'bg-palette-gray-100' : 'bg-palette-green-100'">
                <div class="!w-[6px] !h-[6px] rounded-full"
                    [ngClass]="room.charge ? 'bg-palette-gray-500' : 'bg-palette-green-600'"></div>
            </div>
            <!-- cancellation -->
            <div class="flex flex-col !gap-0.5">
                <p class="text-sm font-medium">
                    <ng-container *ngIf="room.charge !== null">
                        <ng-container [ngSwitch]="room.charge_type">
                            <!-- Trường hợp charge theo đêm đầu tiên -->
                            <span *ngSwitchCase="3">
                                {{ 'CANCELLATION_POLICIES_POPUP.CHARGED_NIGHT' | translate: { chargeValue: room.charge, s: room.charge > 1 ? 's' : '' } }}
                            </span>
                            <!-- Trường hợp charge theo phần trăm -->
                            <span *ngSwitchCase="2">
                                {{ 'CANCELLATION_POLICIES_POPUP.CHARGED_PERCENT' | translate: { chargeValue: room.charge } }}
                            </span>
                            <!-- Trường hợp charge theo số tiền -->
                            <span *ngSwitchCase="1">
                                {{ 'CANCELLATION_POLICIES_POPUP.CHARGED_AMOUT' | translate }} 
                                {{ room.charge | currencyConversion }}
                            </span>
                            <!-- Trường hợp không tính phí -->
                            <span *ngSwitchCase="0">
                                <span class="text-palette-green-600">
                                    {{ 'CANCELLATION_POLICIES_POPUP.FREE_CANCELLATION' | translate }}
                                </span>
                            </span>
                            <span *ngSwitchDefault></span>
                        </ng-container>
                    </ng-container>
                    <ng-container *ngIf="room.charge === null">
                        <span class="text-palette-green-600">
                            {{ 'CANCELLATION_POLICIES_POPUP.FREE_CANCELLATION' | translate }}
                        </span>
                    </ng-container>
                </p>
                <p class="text-sm text-palette-gray-500 font-normal">
                    <!-- for 3rdpary cancel policy -->
                     <ng-container *ngIf="room.from_day == 0 && room.to_day == 0; else otherDays">
                        {{ 'CANCELLATION_POLICIES_POPUP.CANCELLATION_MADE_IN_CHECK_IN_DAY' | translate }}
                    </ng-container>
                    <ng-template #otherDays>
                        {{ 'CANCELLATION_POLICIES_POPUP.BEFORE' | translate }} {{ checkInDate | dateFormat}} {{timeZone}}
                    </ng-template>
                </p>
            </div>
        </div>

         <!-- Xử lý các chính sách hủy nhiều phần -->
         <div *ngIf="cancelPolicies.length > 1" class="flex !gap-1 !h-fit">
            <!-- icon dot -->
            <div class="flex flex-col items-center !gap-0.5">
                <ng-container *ngIf="cancelPolicies.length -1 != i; else squareIcon">
                    <i class="sctr-icon-clock text-base font-medium leading-5  rounded"
                        [ngClass]="room.charge ? 'text-palette-gray-500' : 'text-palette-green-600'"></i>
                </ng-container>
                <ng-template #squareIcon>
                    <div class="!w-4 !h-4 !my-[2px] flex items-center justify-center  rounded-full"
                        [ngClass]="room.charge ? 'bg-palette-gray-100' : 'bg-palette-green-100'">
                        <div class="!w-[6px] !h-[6px] rounded-full"
                            [ngClass]="room.charge ? 'bg-palette-gray-500' : 'bg-palette-green-600'"></div>
                    </div>
                </ng-template>
                <div *ngIf="cancelPolicies.length -1 != i" class="min-w-[2px] !w-[2px] !h-[30px] bg-palette-gray-300 !mb-[2px]">
                </div>
            </div>
            <!-- Cancellation -->
            <div class="flex flex-col !gap-0.5">
                <p class="text-sm font-medium">
                    <ng-container *ngIf="room.charge == null || room.charge_type == 0">
                        <span class="text-palette-green-600">
                            {{ 'CANCELLATION_POLICIES_POPUP.FREE_CANCELLATION' | translate }}
                        </span>
                    </ng-container>
                    <ng-container *ngIf="room.charge && room.charge_type == 3">
                        <span class="text-palette-gray-900">
                            {{ 'CANCELLATION_POLICIES_POPUP.CHARGED_NIGHT' | translate : { chargeValue: room.charge, s: room.charge > 1 ? 's' : '' } }}
                        </span>
                    </ng-container>
                    <ng-container *ngIf="room.charge && room.charge_type == 2">
                        <span class="text-palette-gray-900">
                            {{ 'CANCELLATION_POLICIES_POPUP.CHARGED_PERCENT' | translate : { chargeValue: room.charge } }}
                        </span>
                    </ng-container>
                    <ng-container *ngIf="room.charge && room.charge_type == 1">
                        <span class="text-palette-gray-900">
                            {{ 'CANCELLATION_POLICIES_POPUP.CHARGED_AMOUT' | translate }} 
                            {{ room.charge | currencyConversion }}
                        </span>
                    </ng-container>
                </p>
                <!-- detail -->
                <p class="text-sm text-palette-gray-500 font-normal">
                    <!-- The first policy -->
                    <ng-container *ngIf="i === 0 && room.from_day === null">
                        {{ 'CANCELLATION_POLICIES_POPUP.BEFORE' | translate }} {{ getDateBefore(room.to_day, checkInDate) | dateFormat }} {{timeZone}}
                    </ng-container>
        
                    <!-- The mid policy -->
                    <ng-container *ngIf="room.from_day > 0 && room.to_day > 0">
                        {{ 'CANCELLATION_POLICIES_POPUP.FROM' | translate }}
                        {{ getDateBefore(room.from_day, checkInDate) | dateFormat }}
                        {{ 'CANCELLATION_POLICIES_POPUP.TO' | translate }}
                        {{ getDateBefore(room.to_day, checkInDate) | dateFormat }} {{timeZone}}
                    </ng-container>
        
                    <!-- Last policy -->
                    <ng-container *ngIf="room.from_day > 0 && (room.to_day == 0 || room.to_day == null)">
                        {{ 'CANCELLATION_POLICIES_POPUP.AFTER' | translate }} {{ getDateBefore(room.from_day, checkInDate) | dateFormat }} {{timeZone}}
                    </ng-container>
                    <!-- for 3rdpary cancel policy -->
                    <ng-container *ngIf="room.from_day == 0 && room.to_day == 0">
                        {{ 'CANCELLATION_POLICIES_POPUP.CANCELLATION_MADE_IN_CHECK_IN_DAY' | translate }}
                    </ng-container>
                </p>
            </div>
        </div>
    </ng-container>
</div>
